<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="localDate"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="fechaFormateada"
        :label="localTitle"
        :disabled="localDisabled"
        :prepend-icon="iconoCalendario"
        readonly
        @blur="(localDate = parseDate(fechaFormateada)), $emit('fechaEditada')"
        :error-messages="errorMessage"
        v-bind="attrs"
        v-on="on"
        :clearable="eliminable"
        @click:clear="eliminarFecha"
      ></v-text-field>
    </template>
    <v-date-picker v-model="localDate" scrollable :first-day-of-week="1">
      <v-spacer></v-spacer>
      <v-btn text color="secondary" @click="obtenerFechaHoy"> Hoy </v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="cerrarModal"> Cancelar </v-btn>
      <v-btn text color="primary" @click="updateValue"> OK </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import formatearFecha from "../../mixins/formatearFecha";
import { required } from "vuelidate/lib/validators";

export default {
  //   name: Datepicker,
  props: [
    "date",
    "title",
    "disabled",
    "required",
    "errorMessage",
    "conIcono",
    "clearable",
  ],
  mixins: [formatearFecha],
  data: () => ({
    menu: false,
    modal: false,
    menu2: false,
    localTitle: null,
    localDate: null,
    localDisabled: false,
    localRequired: false,
    localconIcono: true,
    // fechaFormateada: null,
  }),
  validations: {
    fechaFormateada: { required },
  },
  methods: {
    cerrarModal() {
      this.modal = false;
    },
    updateValue() {
      //   this.modal = false;
      this.$refs.dialog.save(this.localDate);
      this.$emit("actualizarFecha", this.localDate);
    },
    obtenerFechaHoy() {
      this.localDate = this.parseDate(
        this.formatDate(new Date().toISOString().substr(0, 10))
      );
    },
    eliminarFecha() {
      this.localDate = null;
      this.$emit("actualizarFecha", this.localDate);
    },
    actualizarFecha(val) {
      this.localDate = val;
    },
  },
  computed: {
    eliminable() {
      return this.clearable === undefined || this.clearable === null
        ? true
        : this.clearable;
    },
    fechaFormateada: {
      get() {
        return this.localDate
          ? this.formatDate(
              // new Date(this.localDate).toISOString().substr(0, 10)
              this.localDate
            )
          : null;
      },
      set() {
        this.localDate = null;
      },
    },
    iconoCalendario() {
      return this.localconIcono ? "mdi-calendar" : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$v.$reset();
    });
    this.localTitle = this.title ? (this.localTitle = this.title) : "Fecha";
    this.localDate = this.date ? this.date : null;
    this.localDisabled = this.disabled ? this.disabled : false;
    this.localRequired = this.required ? this.required : false;
    this.localconIcono = this.conIcono ? this.conIcono : false;
    // this.fechaFormateada = this.date
    //   ? this.formatDate(new Date(this.date).toISOString().substr(0, 10))
    //   : null;
  },
  // beforeUpdate() {
  //   console.log("pepe");
  //   console.log(this.date);
  // },
  // beforeUpdate() {
  //   console.log("pepito");
  // },
  watch: {
    date() {
      this.localDate = this.date;
    },
  },
};
</script>